// Level 1:
export const NAV_TARGET_OVERVIEW = 'overview';
// Level 2:
export const NAV_TARGET_DASHBOARD_TAB = 'dashboardTab';
export const NAV_TARGET_MANAGE_TAB = 'manageTab';
